export const en = {
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    cancel: 'Cancel',
    save: 'Save',
    continue: 'Continue',
    back: 'Back',
    close: 'Close',
    select: 'Select',
    required: 'Required',
    appTitle: 'Fire and Ice',
    goBack: 'Go Back',
    goHome: 'Go to Home',
    success: 'Success',
    inTallinn: 'in Tallinn',
  },

  // Page Titles
  pageTitles: {
    home: 'New Era Wellness Studio',
    book: 'Book a Session',
    pricing: 'Pricing',
    promotions: 'Promotions',
    contact: 'Contact',
    checkBalance: 'Check Gift Card Balance',
    gallery: 'Gallery',
  },

  // Invitation
  invitation: {
    accept: 'Accept Invitation',
    decline: 'Decline Invitation',
    accepted: 'Invitation accepted! Your accounts are now linked.',
    declined: 'Invitation declined.',
    processing: 'Processing your response...',
    error: 'This invitation is invalid, has expired, or the accounts are already linked.',
  },

  // Navigation
  nav: {
    title: 'Fire & Ice',
    home: 'Home',
    bookSession: 'Book a Session',
    myAccount: 'My Account',
    login: 'Log In',
    logout: 'Logout',
    signUp: 'Sign Up',
    giftCards: 'Gift Cards',
    sessionBundles: 'Subscriptions and sessionBundles',
    services: 'Services',
    packages: 'Packages',
    scienceStudies: 'Science',
    sessionBundlesShort: 'Session Bundles',
    pricing: 'Pricing',
    memberships: 'Memberships',
    promotions: 'Promotions',
    about: 'Contact Us',
    gallery: 'Gallery',
  },

  promotions: 'Promotions',

  // About Page
  about: {
    title: 'Contact Us',
    description:
      'Welcome to Fire & Ice. We are dedicated to optimizing your health and vitality through contrast therapy and recovery services.',
    contactInfo: 'Contact Information',
    addressLabel: 'Address',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    howToFindUs: 'How to Find Us',
    directions: 'We are located at Hobujaama 4. Look for the entrance next to the main walkway.',
  },

  // Hero Section
  hero: {
    title: 'Vitality for Life',
    subtitle: 'Fire and Ice — an innovative wellness studio to help you…',
    benefit1: 'Perform Better',
    benefit2: 'Feel Better',
    benefit3: 'Work Better',
    benefit4: 'Sleep Better',
    benefit5: 'Live Better',
  },

  services: 'Services',
  learnMore: 'Learn More',
  ourServices: 'Our Services',
  ourPackages: 'Our Packages',
  packageIncludes: 'Package includes:',
  bookPackage: 'Book a package',
  min: 'min',

  // Auth
  auth: {
    logout: 'Logout',
    accountDeactivated: 'Account Deactivated',
    accountDeactivatedMessage:
      'Your account has been deactivated. Please contact support for assistance.',
  },

  // Session Bundles Page
  sessionBundles: {
    title: 'Our Session Bundles & Memberships',
    subtitle: 'Choose the perfect session bundle for your wellness journey',
    loadingSessionBundles: 'Loading session bundles...',
    loadError: 'Failed to load session bundles. Please try again later.',
    purchase: 'Purchase',
    subscribe: 'Subscribe',
    per: 'per',
    monthlySubscriptions: 'Monthly Subscriptions',
    monthlySubscriptionsSpouse: 'Monthly Subscriptions with Spouse Discount',
    bulkSessionBundles: 'Bulk Session Bundles (One-Time Purchase)',
    bulkSessionBundlesSpouse: 'Bulk Session Bundles with Spouse Discount',
    showSpousePricing: 'Show spouse pricing',
    spouseDisclaimer:
      '* Spouse pricing is available to linked accounts. Eligibility will be confirmed upon login.',
    sessionBundleTypeMonthly: 'Monthly',
    spouseOffer: 'Spouse Offer',
    discountOff: '{{percentage}}% off',
    discountOffForMonths: '{{percentage}}% off for {{months}} months',
    perSession: 'per session',
  },

  // Pricing Page
  pricing: {
    title: 'Our Session Bundles & Memberships',
    subtitle: 'Choose the perfect session bundle for your wellness journey',
    membership: 'Membership',
    sessionBundle: 'Session Bundle',
    package: 'Package',
    pack: 'Pack',
    packs: 'Packs',
    visitsPerMonth: 'Visits/Mo',
    sessions: 'Sessions',
    regularPrice: 'Regular Price',
    price: 'Price',
    openingDeal: 'Opening Deal (-{{percentage}}%)',
    openingDealSessionBundle: 'Opening Deal (-{{percentage}}%)',
    pricePerSession: 'Price/Session',
    notes: 'Notes',
  },

  // Booking Page
  booking: {
    title: 'Book a Session',
    selectService: 'Select a Service',
    selectDateTime: 'Select Date & Time',
    loadingServices: 'Loading services...',
    loadError: 'Failed to load services. Please try again later.',
    duration: 'Duration',
    minutes: 'minutes',
    noAvailableSlots: 'No available time slots',
    selectTime: 'Select Time',
    confirmBooking: 'Confirm Booking',
    bookingDetails: 'Booking Details',
    service: 'Service',
    date: 'Date',
    time: 'Time',
    confirmButton: 'Confirm Booking',
    processing: 'Processing...',
    success: 'Booking confirmed successfully!',
    error: 'Failed to confirm booking. Please try again.',
    step1: 'Step 1 of 3: Choose your service',
    step2: 'Step 2 of 3: Select date and time',
    step3: 'Step 3 of 3: Confirm your booking',
    selectDate: 'Select Date',
    loadingAvailableTimes: 'Loading available times...',
    noAvailableTimesForDate: 'No available times for this date',
    confirmYourBooking: 'Confirm your booking',
    confirmYourDetails: 'Step 3 of 3: Confirm your details',
    serviceLabel: 'Service:',
    dateLabel: 'Date:',
    timeLabel: 'Time:',
    durationLabel: 'Duration:',
    totalLabel: 'Total:',
    contactInformation: 'Contact Information',
    phoneNumberRequired: 'Phone number is required to confirm your booking',
    phoneNumberInvalid: 'Please enter a valid phone number',
    phoneNumberTooShortEst: 'Estonian phone numbers must be at least 7 digits',
    phoneNumberTooLongEst: 'Estonian phone numbers can be at most 8 digits',
    phoneNumberTooShort: 'Phone number is too short',
    phoneNumberTooLong: 'Phone number is too long',
    confirming: 'Confirming...',
    bookingFailed: 'Failed to create booking. Please try again.',
    step2ChooseDateTime: 'Step 2 of 3: Choose date and time',
    bookAllSessions:
      'Please book all therapies included in the package. Sessions may take place on different days.',
    rescheduleTitle: 'Reschedule Booking',
    rescheduleSubtitle: 'Choose a new date and time for your booking',
    currentBooking: 'Current booking',
    confirmReschedule: 'Confirm Reschedule',
    reschedulingSuccess: 'Your booking has been successfully rescheduled!',
    reschedulingError: 'Failed to reschedule booking. Please try again.',
    participantsLabel: 'Participants',
    enterGiftCardCode: 'Please enter a gift card code',
    invalidGiftCardCode: 'Invalid gift card code',
    giftCardError: 'Error applying gift card',
    giftCardRedemptionFailed: 'Gift card redemption failed. Please try again.',
    giftCard: 'Gift Card',
    applying: 'Applying...',
    apply: 'Apply',
    fullyCoveredByGiftCard: 'Your booking is fully covered by the gift card!',
    noPaymentRequired: 'No additional payment is required.',
    balance: 'Balance',
    remainingBalance: 'Remaining Balance',
    remove: 'Remove',
    priceLabel: 'Price:',
    confirmAndPay: 'Confirm and Pay',
    nameRequired: 'Name is required',
    emailRequired: 'Email is required',
    emailInvalid: 'Invalid email format',
    enterYourName: 'Enter your name',
    enterYourEmail: 'Enter your email',
    guestBookingSuccess: 'Booking confirmed! You will receive a confirmation email.',
    bulkBookingSuccess: 'Successfully created {{count}} bookings!',
    bulkBookingSuccessTitle: 'Bookings confirmed successfully!',
    bookAnotherSession: 'Book Another Session',
    chooseHowToProceed: 'Choose how you would like to proceed with your booking:',
    continueAsGuest: 'Continue as Guest',
    loginToBook: 'Log In or Sign Up',
    paymentOption: 'Payment Option',
    isMixedCart:
      'You cannot mix and match service and package payment methods in one checkout. Mixed carts can only be paid by card or on-site.',
    remainingSessions: 'Remaining sessions',
    subscriptions: 'Subscriptions',
    sessionBundles: 'Session Bundles',
    payByCard: 'Pay by Card',
    payAtSite: 'Reserve Now, Pay in Studio',
    paymentMethods: 'Payment Methods',
    infoSavedNote: 'Your information is saved for future bookings',
    unavailableTitle: 'Unavailable Subscriptions and Session Bundles',
    unavailableMessage:
      'These subscriptions and sessionBundles have expired or have been fully used.',
    sessionsRemaining: 'Sessions remaining',
    status: 'Status',
    expired: 'Expired',
    insufficientCredits:
      "You have {{available}} sessions available, but you're trying to book {{required}} sessions.",
    insufficientCreditsActionStart: 'Please ',
    insufficientCreditsActionModify: 'modify your booking',
    insufficientCreditsActionMiddle: ' or ',
    insufficientCreditsActionPurchase: 'purchase an additional session bundle',
    insufficientCreditsActionEnd: '.',
  },

  // Account Page
  account: {
    title: 'My Account',
    personalInfo: 'Personal Information',
    email: 'Email',
    name: 'Name',
    phoneNumber: 'Phone Number',
    gender: 'Gender',
    birthday: 'Birthday',
    upcomingBookings: 'Upcoming Bookings',
    pastBookings: 'Past Bookings',
    cancelledBookings: 'Cancelled Bookings',
    noBookings: 'No bookings found',
    cancelBooking: 'Cancel',
    cancelBookingConfirmTitle: 'Cancel This Booking?',
    cancelBookingConfirmMessage:
      'Are you sure you want to cancel your booking for {{serviceName}} on {{date}} at {{time}}?',
    cancelBookingYes: 'Yes, Cancel Booking',
    cancelBookingNo: 'Keep Booking',
    confirm: 'Confirm',
    rescheduleBooking: 'Reschedule',
    profile: 'Profile',
    mySessionBundle: 'My Session Bundle',
    mySessionBundlesAndSubscriptions: 'My Session Bundles, Subscriptions & Packages',
    bookings: 'Bookings',
    notProvided: 'Not provided',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    sessionsLeft: 'Sessions Left',
    expires: 'Expires',
    activeSessionBundles: 'Active Session Bundles',
    viewAllBookings: 'View all bookings',
    spouseDiscount: 'Spouse Discount',
    spouseDiscountDesc:
      "Enter your spouse's email to grant them access to discounted sessionBundles.",
    sendInvite: 'Send Invite',
    spouse: {
      title: 'Spouse Account',
      linked: 'Your account is linked to: {{email}}',
      pending: 'An invitation is pending for: {{email}}',
      declined:
        'Your previous invitation to {{email}} was declined. You can enter a new email or the same email to try again.',
      invite: "Enter your spouse's email to send a linking invitation.",
    },
    manageSubscription: 'Manage Subscription',
    sessionsRemaining: 'Sessions Remaining',
    sessionsUsed: 'Sessions used/booked',
    renewalDate: 'Renewal Date',
    activeSubscription: 'Active Subscription',
    renewsOn: 'Renews on',
    loadingBookings: 'Loading bookings...',
    noBookingsYet: 'No bookings yet. Book your first session!',
    minutes: 'minutes',
    phoneNumberUpdated: 'Phone number updated successfully!',
    preferencesUpdated: 'Preferences updated successfully!',
    promoOptIn: 'I would like to receive promotional emails and newsletters.',
    invitationSent: 'Invitation sent successfully!',
    welcomeMessage:
      "Thank you for signing up at Fire & Ice! We're thrilled to have you join our wellness community. Take a moment to explore your account and discover all the amazing services we offer.",
    // Booking cancellation
    bookingCancelledSuccess: 'Booking cancelled successfully!',
    bookingCancelFailed: 'Failed to cancel booking. Please try again.',
    cancellationPolicy24Hours:
      'Bookings cannot be cancelled within 24 hours of the appointment time.',
    reschedulingPolicy24Hours:
      'Bookings cannot be rescheduled within 24 hours of the appointment time.',
    cannotCancel24Hours: 'Cannot cancel',
    cannotReschedule24Hours: 'Cannot reschedule',
    cancellationPolicyNotice:
      'Note: Bookings cannot be cancelled within 24 hours of the appointment time.',
    // Phone number validation errors
    phoneNumberTooShortEst: 'Estonian phone numbers must have at least 7 digits',
    phoneNumberTooLongEst: 'Estonian phone numbers can have maximum 8 digits',
    phoneNumberTooShort: 'Phone number is too short',
    phoneNumberTooLong: 'Phone number is too long',
    phoneNumberInvalid: 'Please enter a valid phone number',
    unusedSessionsNote: 'Your unused sessions will roll over for up to 3 months.',
    confirmed: 'confirmed',
    cancelled: 'cancelled',
    at: 'at',
    sessionsRolledOver: 'Rolled over',
    expiresOn: 'Expires',
    bookAgain: 'Book Again',
    filterAll: 'All',
    filterUpcoming: 'Upcoming',
    filterPast: 'Past',
    filterCancelled: 'Cancelled',
    searchBookings: 'Search bookings...',
    noUpcomingBookings: 'No upcoming bookings',
    readyToBook: 'Ready to book your next wellness session?',
    noPastBookings: 'No past bookings',
    bookingHistoryWillAppear: 'Your booking history will appear here',
    noCancelledBookings: 'No cancelled bookings',
    cancelledBookingsWillAppear: 'Cancelled bookings will appear here',
    bookYourFirstSession: 'Book Your First Session',
    participants: 'participants',
    loadingSessionBundles: 'Loading session bundles...',
    noActiveSessionBundles: 'No active session bundles',
    myPackagePacks: 'My Package Packs',
    noActivePackagePacks: 'No active package packs',
    packsRemaining: 'Packs Remaining',
    packsUsed: 'Packs used',
    usedPackagePacksTitle: 'Used Package Packs',
    // Subscription management
    mySubscription: 'My Subscription',
    subscription: 'Subscription',
    cancelSubscription: 'Cancel Subscription',
    cancelConfirmTitle: 'Cancel Subscription?',
    cancelConfirmMessage:
      'Are you sure you want to cancel? Your benefits will continue until {{endDate}}.',
    cancelSuccess: 'Your subscription has been cancelled and will expire on {{endDate}}.',
    cancelError: 'Failed to cancel subscription. Please contact support.',
    subscriptionExpires: 'Your subscription is active and will expire on {{endDate}}.',
    subscriptionRenews: 'Your subscription renews on {{endDate}}.',
    keep: 'Keep Subscription',
    noActiveSubscription: 'No active subscriptions',
    nameRequired: 'Name is required',
    nameUpdated: 'Name updated successfully',
    emailInvalid: 'Please enter a valid email address',
    emailUpdateInitiated:
      'Verification required. Please check your new email address for a confirmation link.',
    emailChangeSubmitted:
      'We have sent a verification link to your new email address. Please click the link in that email to complete the change.',
    expiredSectionTitle: 'Expired Subscriptions and Used Session Bundles',
    subscriptionExpiredOn: 'Expired on',
    sessionBundleFullyUsed: 'Session bundle fully used',
    notificationPreferences: 'Notification Preferences',
    receiveEmailReminders: 'Receive booking reminders via e-mail',
    receiveSmsReminders: 'Receive booking reminders via SMS',
    noPhoneNumber: 'No phone number',
    addPhoneToEnable: 'Add phone to enable',
    session: 'Session',
  },

  // Email Verification
  verifyEmail: {
    title: 'Email Verification',
    verifying: 'Verifying your email...',
    success: 'Your email has been successfully updated!',
    errorTitle: 'Verification Failed',
    noToken: 'No verification token found.',
    genericError: 'An error occurred.',
    backToAccount: 'Go to My Account',
    redirecting: 'You will be redirected to your profile in 3 seconds...',
    clickHereToReturn: 'If you are not redirected, click here to return to your profile.',
  },

  // Email Templates
  email: {
    verification: {
      subject: 'Verify Your New Email Address for Fire & Ice',
      heading: 'Verify Your New Email Address',
      body: 'You recently requested to change the email address associated with your Fire & Ice account. To confirm this change, please click the button below. The link is valid for 1 hour.',
      button: 'Confirm Your New Email',
      disclaimer: 'If you did not request this email change, you can safely ignore this email.',
    },
    bookingConfirmation: {
      subject: 'Your Fire & Ice Booking Confirmation',
      heading: 'Booking Confirmed!',
      greeting: 'Hello',
      bodyIntro: 'Thank you for your booking. Here are the details of your upcoming session(s):',
      bookingListHeader: 'Your Bookings',
      payAtSiteLabel: 'Amount to Pay at the Studio',
    },
    bookingReminder: {
      subject: 'Reminder: Your Fire & Ice Booking Tomorrow',
      heading: '⏰ Booking Reminder',
      greeting: 'Hello',
      bodyIntro: 'This is a friendly reminder that you have a booking scheduled for tomorrow.',
      closingMessage: 'We look forward to seeing you!',
      footerMessage: 'This is an automated reminder for your upcoming booking.',
    },
    dailyReminder: {
      subject: 'Reminder: Your Fire & Ice Bookings Today',
      heading: 'Fire & Ice Booking Reminder',
      greeting: 'Hello',
      greetingSingle: 'You have an appointment today:',
      greetingMultiple: 'You have {{count}} appointments today:',
      closingMessage: 'We look forward to seeing you!',
      footerMessage: 'This is an automated reminder for your upcoming booking(s).',
    },
    purchaseConfirmation: {
      subject: 'Your Fire & Ice Purchase Confirmation',
      heading: 'Purchase Confirmed!',
      bodyIntroSessionBundle:
        'Thank you for your purchase! Your new session bundle is active and ready to use.',
      bodyIntroSubscription:
        'Thank you for your purchase! Your new subscription is active and ready to use.',
      detailsLabel: 'Purchase Details:',
      priceLabel: 'Amount Paid:',
      sessionBundleInfo:
        'You have purchased {{sessions}} sessions. There is no time limit to use your sessions - they never expire!',
      subscriptionInfo:
        'Your subscription will automatically renew on {{renewalDate}}. Unused sessions will roll over for up to 3 months. You can cancel your subscription anytime from your account section on the Fire & Ice website.',
      ctaHeading: 'Ready to Get Started?',
      ctaBody:
        "Explore our range of wellness services and book your first session today. We can't wait to welcome you to Fire & Ice!",
      ctaButton: 'Book Your First Session',
    },
    rescheduleConfirmation: {
      subject: 'Your Fire & Ice Booking Has Been Rescheduled',
      heading: 'Booking Rescheduled',
      bodyIntro: 'Your booking for the following service has been successfully rescheduled:',
      serviceLabel: 'Service:',
      oldBookingHeading: 'Previous Time',
      newBookingHeading: 'New Time',
      dateLabel: 'Date:',
      timeLabel: 'Time:',
    },
    cancellationConfirmation: {
      subject: 'Your Fire & Ice Booking Has Been Cancelled',
      heading: 'Booking Cancelled',
      bodyIntro: 'Your booking for the following service has been successfully cancelled:',
      bookingDetails: 'Cancelled Booking Details:',
      serviceLabel: 'Service:',
      dateLabel: 'Date:',
      timeLabel: 'Time:',
      refundNoticeSessionBundle:
        'A session credit has been returned to your active session bundle.',
      refundNoticeSubscription: 'A session credit has been returned to your active subscription.',
      refundNoticePaid: 'Your booking was paid by card and is non-refundable.',
      refundNoticeDefault: 'Your booking has been cancelled.',
    },
    spouseInvite: {
      subject: 'Spouse Account Invitation - Fire & Ice',
      heading: "You're Invited!",
      body: 'has invited you to link your Fire & Ice account as a spouse.',
      acceptButton: 'Accept Invitation',
      declineButton: 'Decline',
    },
    spouseResponse: {
      subject: 'Spouse Account Response - Fire & Ice',
      heading: 'Invitation Response',
      bodyAccepted: 'has accepted your spouse account invitation!',
      bodyDeclined: 'has declined your spouse account invitation.',
    },
    footer: {
      company: 'Fire and Ice',
      address: 'Hobujaama tn 4, Tallinn',
      emailSentTo: 'This email was sent to',
      reason: 'You received this email because you registered for an account at Fire & Ice.',
    },
  },

  // Complete Registration
  registration: {
    title: 'Complete Your Registration',
    subtitle: 'Please provide the following information to complete your account setup',
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    phoneNumberPlaceholder: 'e.g., +372 5123 4567',
    submit: 'Complete Registration',
    submitting: 'Submitting...',
    success: 'Registration completed successfully!',
    error: 'Failed to complete registration. Please try again.',
    oneLastStep: 'One Last Step...',
    welcome: 'Welcome to Fire & Ice',
    reviewTerms: 'Please review and agree to the terms below to complete your registration.',
    agreeToTerms: 'I agree to the',
    termsOfService: 'Terms of Service',
    promoOptIn: 'I would like to receive promotional emails and newsletters.',
    agreeToEmails: 'I agree to receive promotional emails',
    completeSignUp: 'Complete Sign-up',
    completing: 'Completing...',
    mustAgreeToTerms: 'You must agree to the Terms of Service to continue.',
    errorOccurred: 'An error occurred. Please try again.',
    nameLabel: 'Full Name',
    namePlaceholder: 'Enter your full name',
    nameRequired: 'Please enter your name.',
    gender: 'Gender',
    genderPlaceholder: 'Select your gender',
    male: 'Male',
    female: 'Female',
    birthday: 'Birthday',
    birthdayPlaceholder: 'Select your birthday',
    birthdayInFuture: 'Birthday cannot be in the future',
  },

  // Error messages
  errors: {
    unauthorized: 'You need to be logged in to access this page',
    notFound: 'Page not found',
    general: 'Something went wrong. Please try again.',
    // Auth callback errors
    authenticationError: 'Authentication Error',
    authenticationErrorMessage:
      'We encountered an error during authentication. You will be redirected to the home page.',
    authError: 'Error: {{message}}',
    redirecting: 'Redirecting...',
    authenticating: 'Authenticating...',
    loading: 'Loading...',
    missingCallbackParams: 'Missing required callback parameters',
    // Auth0 configuration errors
    auth0ConfigMissing:
      'Auth0 configuration missing. Please check REACT_APP_AUTH0_DOMAIN and REACT_APP_AUTH0_CLIENT_ID environment variables.',
    auth0ConfigError: 'Auth0 configuration error. Please check console for details.',
    confirmationFailed: 'Confirmation failed. ',
    paymentNotSucceeded: 'Payment was not successful.',

    // API Error Codes
    api: {
      AUTH_TOKEN_MISSING: 'Authentication required. Please log in.',
      AUTH_TOKEN_INVALID: 'Your session has expired. Please log in again.',
      AUTH_UNAUTHORIZED: "You don't have permission to perform this action.",

      BOOKING_NOT_FOUND: 'Booking not found.',
      BOOKING_CANNOT_CANCEL: 'Cannot cancel booking within 24 hours of appointment time.',
      BOOKING_ALREADY_CANCELLED: 'This booking has already been cancelled.',
      BOOKING_SLOT_UNAVAILABLE: 'This time slot is no longer available.',
      BOOKING_INVALID_DATA: 'Invalid booking information provided.',
      BOOKING_REQUIRED_FIELDS_MISSING: 'Required booking information is missing.',
      BOOKING_BULK_PARTIAL_FAILURE: 'Some bookings could not be completed.',
      BOOKING_BULK_COMPLETE_FAILURE: 'Unable to complete bookings.',

      PAYMENT_REQUIRED: 'Payment is required to complete this booking.',
      PAYMENT_FAILED: 'Payment failed. Please try again.',
      PAYMENT_INVALID_AMOUNT: 'Invalid payment amount.',
      PAYMENT_CARD_DECLINED: 'Your card was declined. Please try a different payment method.',

      GIFT_CARD_NOT_FOUND: 'Gift card not found or invalid.',
      GIFT_CARD_INSUFFICIENT_BALANCE: 'Insufficient gift card balance.',
      GIFT_CARD_INVALID_AMOUNT: 'Invalid gift card amount.',

      PROMO_CODE_NOT_FOUND: 'Promotion code not found or invalid.',

      SESSION_BUNDLE_NOT_FOUND: 'Session bundle or subscription not found.',
      SESSION_BUNDLE_NO_USES_REMAINING: 'No remaining uses on this session bundle.',
      SESSION_BUNDLE_ALREADY_PURCHASED: 'You already own this session bundle.',

      USER_NOT_FOUND: 'User not found.',
      CLIENT_NOT_FOUND: 'Client not found.',

      SERVICE_NOT_FOUND: 'Service not found.',
      SERVICE_UNAVAILABLE: 'This service is currently unavailable.',

      INVALID_REQUEST: 'Invalid request.',
      VALIDATION_ERROR: 'Please check your input and try again.',

      INTERNAL_ERROR: 'An error occurred. Please try again.',
      EXTERNAL_API_ERROR: 'Service temporarily unavailable. Please try again later.',
    },
  },

  // Date/Time formatting
  dateTime: {
    today: 'Today',
    tomorrow: 'Tomorrow',
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
  },

  // Footer
  footer: {
    services: 'SERVICES',
    infraredSauna: 'Infrared Sauna',
    coldPlunge: 'Cold Plunge',
    cryotherapy: 'Cryotherapy',
    redLightTherapy: 'Red Light Therapy',
    cellumaFacialLightTherapy: 'Celluma Facial Light Therapy',
    compressionMassage: 'Compression Massage',
    gallery: 'GALLERY',
    scienceAndStudies: 'SCIENCE & STUDIES',
    specialOffers: 'SPECIAL OFFERS',
    pricing: 'PRICING',
    bookNow: 'BOOK NOW',
    copyright: '© {year} by Fire and Ice. All rights reserved.',
    checkGiftCardBalance: 'Check Gift Card Balance',
    privacyNotice: 'Privacy Notice',
    termsOfService: 'Terms of Service',
  },

  // Promotion
  promo: {
    code: 'Promo code',
    have: 'Have a promo code?',
    applied: 'Promo code applied',
    placeholder: 'Enter promo code',
    errors: {
      missingCode: 'Please enter a promo code.',
      validationError: 'An error occurred while validating the promo code.',
      invalidCode: 'Invalid promo code',
    },
  },

  // Gift Card
  giftCard: {
    have: 'Have a gift card?',
    applied: 'Gift card applied',
    purchaseTitle: 'Purchase a Digital Fire & Ice Gift Card',
    purchaseDescription:
      'This gift card is valid for one year and can be used to pay for bookings, purchasing sessionBundles or subscriptions.',
    chooseAmount: 'Choose an Amount',
    other: 'Other',
    enterAmountPlaceholder: 'Enter amount - minimum 50 €',
    to: 'To:',
    recipientName: "Recipient's Name",
    recipientNamePlaceholder: 'John Doe',
    deliveryEmail: 'Delivery Email',
    recipientEmailPlaceholder: 'john@example.com',
    from: 'From:',
    yourName: 'Your Name',
    yourNamePlaceholder: 'Your Name',
    yourEmail: 'Your Email',
    yourEmailPlaceholder: 'your@example.com',
    yourPhone: 'Your Phone',
    yourPhonePlaceholder: '+372 5123 4567',
    personalMessage: 'Add a Personal Message (Optional)',
    personalMessagePlaceholder: 'Write your message here...',
    characters: 'characters',
    processing: 'Processing...',
    proceedToPayment: 'Proceed to Payment',
    completePayment: 'Complete Payment',
    minimumAmountError: 'Minimum gift card amount is 50 €',
    successMessage: 'Gift card created successfully! Code: {{code}}',
    errorMessage: 'Failed to create gift card. Please check your details and try again.',
    session: '{{count}} session',
    sessions: '{{count}} sessions',
    // Gift Card Balance Page
    balancePageTitle: 'Check Your Gift Card Balance',
    balancePageSubtitle: 'Enter your gift card code below to see the remaining balance.',
    codePlaceholder: 'XXXX-XXXX-XXXX',
    checkingBalance: 'Checking...',
    checkBalance: 'Check Balance',
    currentBalance: 'Current Balance:',
    invalidCode: 'Invalid gift card code.',
    checkError: 'An error occurred. Please try again.',
    enterCode: 'Please enter a gift card code.',
    cardDepleted: 'This gift card has been fully redeemed and is no longer valid.',
    successPageTitle: 'Gift Card Purchase Successful!',
    successPageMessage: 'Your gift card has been purchased and sent to the recipient.',
    detailsTitle: 'Purchase Details',
    giftCardCode: 'Gift Card Code',
    codeInfo: 'The recipient will receive this code via email.',
    amount: 'Amount',
    emailConfirmation: 'A confirmation email has been sent to {{email}}.',
    emailSubject: "You've received a gift card from {{senderName}}!",
    emailHeading: "You've Received a Gift Card!",
    emailIntro: 'has sent you a gift card!',
    amountLabel: 'Gift Card Value',
    codeLabel: 'Your Gift Card Code',
    messageLabel: 'Personal Message',
    emailInstructions:
      'Use this code when booking your next session at Fire & Ice, or towards the purchase of sessionBundles and subscriptions.',
    ctaText: 'Book Now',
  },

  // Booking Upsell
  upsell: {
    message: "Booking individual sessions? It's cheaper to use a subscription or session bundle.",
    linkText: 'View Session Bundles & Memberships',
  },

  // Service Page
  servicePage: {
    bookNow: 'Book Now',
  },

  // Booking Cart
  cart: {
    title: 'Your Booking Selection',
    empty: 'Your selection is empty.',
    addToCart: 'Book Time',
    bookNow: 'Book Now',
    addedToCart: 'Added to your booking selection!',
    bookingChanged: 'Booking has been changed',
    change: 'Change',
    remove: 'Remove',
    confirmRemove: 'Are you sure you want to remove this booking from your cart?',
    total: 'Total',
    at: 'at',
    addAnotherService: 'Add Another Service',
    proceedToCheckout: 'Finalize Booking',
    suggestedServices: 'Continue Your Wellness Journey',
    suggestedServicesDescription:
      'These services are available immediately after your last booking:',
    available: 'Available at',
    bookingSelected: '{{count}} Booking Selected',
    bookingsSelected: '{{count}} Bookings Selected',
    removeBookingTitle: 'Remove Booking',
    confirmChange: 'Confirm Change',
    credits: 'Credits',
    participants: 'Participants:',
    participantEmails: 'Participant Emails (optional):',
    participantEmailPlaceholder: 'Participant {{count}} email',
  },

  // Checkout Page
  checkout: {
    title: 'Checkout',
    bookingSummary: 'Booking Summary',
    orderSummary: 'Order Summary',
    paymentDetails: 'Payment Details',
    securePaymentInfo: 'Your payment is securely processed by Stripe.',
    cardDetails: 'Card Details',
    cardNumber: 'Card Number',
    expiryDate: 'Expiry Date',
    cvc: 'CVC',
    processing: 'Processing...',
    completeOrder: 'Complete Order',
    payAmount: 'Pay {{amount}}',
    cardElementError: 'Card element not found',
    paymentError: 'Payment failed. Please try again.',
    sessionBundleNotFound: 'Session bundle not found',
    packagePackNotFound: 'Package pack not found',
    loadError: 'Failed to load session bundle details',
    enterGiftCardCode: 'Please enter a gift card code',
    giftCardNoBalance: 'This gift card has no balance',
    invalidCode: 'Invalid code',
    monthlySubscription: 'Monthly Subscription',
    bulkSessionBundle: 'Bulk Session Bundle',
    sessions: 'sessions',
    subtotal: 'Subtotal',
    promotionDiscount: 'Promotion Discount',
    promotionCodeDiscount: 'Promotion Code Discount',
    giftCardDiscount: 'Gift Card Discount',
    total: 'Total',
    enterCode: 'Enter code',
    apply: 'Apply',
    remove: 'Remove',
    customerInfo: 'Customer Information',
    name: 'Name',
    email: 'Email',
    unavailable: 'Unavailable',
    unavailableItemsMessage:
      'Some bookings are no longer available. Please remove them to continue.',
    removeUnavailable: 'Remove Unavailable Bookings',
    bookingInfo:
      'Your bookings will be confirmed immediately. You can manage them from your account page.',
    confirmBookings: 'Confirm Bookings',
    processingOrder: 'Processing Order',
    pleaseWait: 'Please wait while we confirm your purchase...',
  },

  // Purchase Confirmation Page
  confirmation: {
    title: 'Purchase Confirmation',
    successTitle: 'Thank You for Your Purchase!',
    successMessage: 'Your order has been successfully completed.',
    noData: 'No order information available',
    orderDetails: 'Order Details',
    sessionBundle: 'Session Bundle',
    subscription: 'Subscription',
    amountPaid: 'Amount Paid',
    paymentMethod: 'Payment Method',
    giftCardOnly: 'Gift Card',
    cardAndGiftCard: 'Credit Card & Gift Card',
    whatNext: "What's Next?",
    confirmationEmail: 'You will receive a confirmation email shortly with your purchase details.',
    bookSession: 'Book a Session',
    goToAccount: 'Go to My Account',
    contractError: 'There was an issue activating your session bundle. Please contact support.',
    creatingContract: 'Finalizing your purchase, please wait...',
  },

  // Newsletter
  newsletter: {
    title: 'Stay Updated',
    subtitle: 'Subscribe to our newsletter for the latest updates and wellness tips.',
    firstNamePlaceholder: 'First Name',
    lastNamePlaceholder: 'Last Name',
    emailPlaceholder: 'Enter your email',
    subscribing: 'Subscribing...',
    subscribe: 'Subscribe',
    successMessage: 'Thank you for subscribing!',
    errorMessage: 'Something went wrong. Please try again.',
  },

  // Console messages (for debugging)
  console: {
    errors: {
      fetchingBookings: 'Error fetching bookings:',
      fetchingUserSessionBundles: 'Error fetching user sessionBundles:',
      cancellingBooking: 'Error cancelling booking:',
      fetchingSessionBundles: 'Error fetching session bundles:',
      fetchingServices: 'Error fetching services:',
      completingRegistration: 'Error completing registration:',
      creatingBooking: 'Error creating booking:',
      fetchingService: 'Error fetching service:',
      fetchingAvailability: 'Error fetching availability:',
      reschedulingBooking: 'Error rescheduling booking:',
      fetchingGiftCardBalance: 'Error fetching gift card balance:',
      giftCardRedemptionFailed: 'Gift card redemption failed:',
      creatingGiftCard: 'Error creating gift card:',
      authCallbackError: 'Auth0 callback error:',
      authErrorDetails: 'Auth0 error details:',
    },
  },

  // Coupon Codes
  coupon: {
    title: 'Coupon Code',
    haveCoupon: 'Have a coupon code?',
    placeholder: 'Enter coupon code',
    applied: 'Coupon applied!',
    sessionsIncluded: '{{count}} sessions included',
    sessionsAlreadyUsed: '{{count}} session(s) already used',
    bookAnotherLater: 'Book another session later to use your free session!',
    youSave: 'You save',
    cancellationPolicyTitle: 'Linked Booking Policy',
    cancellationPolicyText:
      'Both sessions must be cancelled together. If you cancel one session, both sessions will be cancelled and the coupon will be restored for future use.',
    // Coupon pair cancellation
    sessionBadge: 'Coupon',
    cancelPairTitle: 'Cancel Coupon Sessions',
    linkedBookingNotice: 'Linked Coupon Booking',
    pairCancellationExplanation:
      'This booking is part of a coupon pair. Both sessions must be cancelled together for a full refund.',
    pairCancellationConfirm:
      'Cancelling will cancel both coupon sessions and refund {{amount}}. Your coupon code will be restored for future use.',
    linkedSessions: 'Linked sessions to cancel:',
    cancelBothSessions: 'Cancel Both Sessions',
    pairCancellationSuccess:
      'Both coupon sessions cancelled successfully. {{amount}} refunded. Coupon restored for reuse.',
    errors: {
      missingCode: 'Please enter a coupon code.',
      missingEmail: 'Email address is required to validate the coupon.',
      invalidCode: 'This coupon code is invalid or has expired.',
      alreadyUsed: 'This coupon code has already been fully redeemed.',
      noSessions: 'Please add at least one session to your cart.',
      validationError: 'An error occurred while validating the coupon code.',
      sessionAlreadyUsed:
        'Cannot cancel: one or more linked sessions have already been used. You may still be able to reschedule within 24 hours of the appointment.',
      cannotCancel: 'Unable to cancel these sessions at this time.',
    },
    success: "Coupon applied! You're saving {{discount}}.",
  },

  // Gallery
  gallery: {
    title: 'Gallery',
    subtitle: 'Explore moments from our wellness studio',
    pageTitle: 'Gallery',
    pageDescription: 'Browse our gallery of wellness experiences at Fire & Ice in Tallinn.',
    viewImage: 'View image',
    lightboxLabel: 'Image lightbox',
    previousImage: 'Previous image',
    nextImage: 'Next image',
    loadError: 'Failed to load gallery',
    noImages: 'No images available',
  },

  // SEO
  seo: {
    defaultTitle: 'Fire & Ice - Wellness & Recovery',
    defaultDescription:
      'Experience the ultimate wellness journey with Fire & Ice. Premium contrast therapy services including sauna, cold plunge, and more in Tallinn.',
    homeDescription:
      'Fire and Ice is a place where you can unwind and let yourself be cared for. Facial and body treatments that support both beauty and health. Book your appointment today.',
    privacyDescription:
      'Read our privacy policy to get a clear overview of how we collect, use, and protect your personal data. Learn more.',
    bookDescription:
      'Book a Fire and Ice wellness treatment at a time that suits you. Choose a service and time to enjoy a new era of wellness experience. We look forward to seeing you!',
    termsDescription:
      'Fire and Ice terms of service explain the rules for using our services, user rights, and responsibilities. We recommend reading the terms before booking.',
    pricingDescription:
      'Check out the Fire and Ice price list and session bundle options. Find the solution that suits you and book a session comfortably.',
    promotionsDescription:
      'Discover Fire and Ice special offers and campaigns. Take the opportunity to try wellness treatments at a lower price and book an appointment comfortably.',
    contactDescription:
      'Find Fire and Ice contact details and location. If you have any questions about services or booking, please contact us.',
    scienceStudiesDescription:
      'Our services are based on scientific research and evidence-based methods. Learn more about how they help you recover and feel better.',
    checkBalanceDescription:
      'Enter your details to instantly see the remaining balance on your Fire and Ice gift card. Simple, fast, and convenient!',
    galleryDescription:
      'Browse our gallery of wellness experiences at Fire & Ice. See our sauna, cold plunge, and recovery facilities in Tallinn.',
    services: {
      'infrared-sauna':
        'Infrared sauna helps relax, supports recovery, and improves well-being. Enjoy a peaceful environment and book a session comfortably online.',
      'compression-massage':
        'Compression massage improves circulation and supports recovery. Relax, recover, and book a session comfortably online.',
      'contrast-therapy':
        'Contrast therapy combines the effects of cold and heat to help the body recover and improve well-being. Book a session comfortably online.',
      'celluma-facial-light-therapy':
        'Celluma LED light therapy for the face helps improve skin texture, reduce inflammation, and support collagen production. Book a session.',
      'cryotherapy-full-body':
        'Full body cryotherapy offers an intense cold experience that supports recovery and improves well-being. Book a session comfortably online.',
      'cold-plunge':
        'Cold plunge offers a refreshing experience that supports recovery and improves well-being. Experience the power of cold and book a session comfortably.',
      'red-light-therapy':
        'Red light therapy helps the body recover and boosts well-being. Take time off and book a session simply online.',
    },
  },

  // Birthday Picker
  birthdayPicker: {
    selectYear: 'Select Year',
    selectMonth: 'Select Month',
    selectDay: 'Select Day',
    placeholder: 'dd/mm/yyyy',
  },
};

export type TranslationKeys = typeof en;
